import { useTranslation } from 'react-i18next';
import { LegalPage, LegalSection } from '@/components/shared/LegalPage';

/**
 * Conditions Générales d'Utilisation — page publique standard.
 *
 * Texte placeholder à remplacer par un document rédigé/relu par un juriste
 * avant ouverture commerciale. Suffit en l'état pour la verification
 * Google OAuth et pour servir de point d'ancrage légal pendant la beta.
 */
export default function TermsOfService() {
  const { t } = useTranslation(['pages']);
  const s2Items = t('pages:legal.termsOfService.s2.items', { returnObjects: true }) as unknown as string[];
  const s4Items = t('pages:legal.termsOfService.s4.items', { returnObjects: true }) as unknown as string[];

  const sections = [
    { id: 's1', heading: t('pages:legal.termsOfService.s1.heading') },
    { id: 's2', heading: t('pages:legal.termsOfService.s2.heading') },
    { id: 's3', heading: t('pages:legal.termsOfService.s3.heading') },
    { id: 's4', heading: t('pages:legal.termsOfService.s4.heading') },
    { id: 's5', heading: t('pages:legal.termsOfService.s5.heading') },
    { id: 's6', heading: t('pages:legal.termsOfService.s6.heading') },
    { id: 's7', heading: t('pages:legal.termsOfService.s7.heading') },
    { id: 's8', heading: t('pages:legal.termsOfService.s8.heading') },
    { id: 's9', heading: t('pages:legal.termsOfService.s9.heading') },
    { id: 's10', heading: t('pages:legal.termsOfService.s10.heading') },
    { id: 's11', heading: t('pages:legal.termsOfService.s11.heading') },
    { id: 's12', heading: t('pages:legal.termsOfService.s12.heading') },
  ];

  return (
    <LegalPage
      title={t('pages:legal.termsOfService.title')}
      lastUpdated={t('pages:legal.termsOfService.lastUpdated')}
      sections={sections}
      related={{ to: '/confidential', label: t('pages:legal.termsOfService.privacyLink') }}
    >
      <LegalSection id="s1" heading={t('pages:legal.termsOfService.s1.heading')}>
        <p>
          {t('pages:legal.termsOfService.s1.body')}
        </p>
      </LegalSection>

      <LegalSection id="s2" heading={t('pages:legal.termsOfService.s2.heading')}>
        <p>
          {t('pages:legal.termsOfService.s2.intro')}
        </p>
        <ul >
          {s2Items.map((item, idx) => <li key={idx}>{item}</li>)}
        </ul>
      </LegalSection>

      <LegalSection id="s3" heading={t('pages:legal.termsOfService.s3.heading')}>
        <p>
          {t('pages:legal.termsOfService.s3.body')}
        </p>
      </LegalSection>

      <LegalSection id="s4" heading={t('pages:legal.termsOfService.s4.heading')}>
        <p>{t('pages:legal.termsOfService.s4.intro')}</p>
        <ul >
          {s4Items.map((item, idx) => <li key={idx}>{item}</li>)}
        </ul>
        <p>
          {t('pages:legal.termsOfService.s4.outro')}
        </p>
      </LegalSection>

      <LegalSection id="s5" heading={t('pages:legal.termsOfService.s5.heading')}>
        <p>
          {t('pages:legal.termsOfService.s5.body')}
        </p>
      </LegalSection>

      <LegalSection id="s6" heading={t('pages:legal.termsOfService.s6.heading')}>
        <p>
          {t('pages:legal.termsOfService.s6.body')}
        </p>
      </LegalSection>

      <LegalSection id="s7" heading={t('pages:legal.termsOfService.s7.heading')}>
        <p>
          {t('pages:legal.termsOfService.s7.body')}
        </p>
      </LegalSection>

      <LegalSection id="s8" heading={t('pages:legal.termsOfService.s8.heading')}>
        <p>
          {t('pages:legal.termsOfService.s8.body')}
        </p>
      </LegalSection>

      <LegalSection id="s9" heading={t('pages:legal.termsOfService.s9.heading')}>
        <p>
          {t('pages:legal.termsOfService.s9.body')}
        </p>
      </LegalSection>

      <LegalSection id="s10" heading={t('pages:legal.termsOfService.s10.heading')}>
        <p>
          {t('pages:legal.termsOfService.s10.prefix')}{' '}
          <a href="/confidential">{t('pages:legal.termsOfService.s10.link')}</a>
          {t('pages:legal.termsOfService.s10.suffix')}
        </p>
      </LegalSection>

      <LegalSection id="s11" heading={t('pages:legal.termsOfService.s11.heading')}>
        <p>
          {t('pages:legal.termsOfService.s11.body')}
        </p>
      </LegalSection>

      <LegalSection id="s12" heading={t('pages:legal.termsOfService.s12.heading')}>
        <p>
          {t('pages:legal.termsOfService.s12.prefix')} <a href="mailto:contact@revcall.com">contact@revcall.com</a>.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
